import React, { useState, useEffect, useRef } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Nav from 'react-bootstrap/Nav';
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as ArrowSVG } from '../assets/icons/svg/arrowUnder.svg';
import { useUser } from '../contexts/UserContext';
import { apiGet } from '../utils/api';

export default function Sidebar({ isToggled, onLinkClick }) {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [regionTabs, setRegionTabs] = useState([]);
  const [lineTabs, setLineTabs] = useState([]);
  const hasFetchedTabsRef = useRef(false);
  const { user, setUser } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isToggled || hasFetchedTabsRef.current) return;
    hasFetchedTabsRef.current = true;

    const toArray = (res) => {
      if (!res) return [];
      if (Array.isArray(res)) return res;
      if (res.data && Array.isArray(res.data)) return res.data;
      if (typeof res === 'object') return Object.values(res);
      return [];
    };

    const fetchRegionTabs = async () => {
      try {
        const response = await apiGet("/navigation/get_region_tabs.php", { summary: 1 });
        const tabs = toArray(response.data).map(({ id, name }) => ({ id, name }));
        setRegionTabs(tabs);
      } catch (error) {
        console.error("지역 탭 데이터 로딩 실패:", error);
      }
    };

    const fetchLineTabs = async () => {
      try {
        const response = await apiGet("/navigation/get_line_tabs.php");
        const tabs = toArray(response.data).map(({ id, name }) => ({ id, name }));
        setLineTabs(tabs);
      } catch (error) {
        console.error("선사 탭 데이터 로딩 실패:", error);
      }
    };

    fetchRegionTabs();
    fetchLineTabs();
  }, [isToggled]);

  const toggleDropdown = (key) => {
    setOpenDropdown(prev => (prev === key ? null : key));
  };

  const handleLogout = async () => {
    try {
      const res = await apiGet('/member/logout.php');
      if (res.result === 'success') {
        setUser(null);
        onLinkClick();
        navigate('/');
      } else {
        alert('로그아웃 실패: ' + (res.message || '알 수 없는 오류'));
      }
    } catch (error) {
      console.error('Logout error:', error);
      alert('서버 오류로 로그아웃에 실패했습니다.');
    }
  };

  return (
    <Offcanvas
      show={isToggled}
      onHide={onLinkClick}
      placement="end"
      scroll={false}
      backdrop={true}
      className='sidebar'
    >
      <Offcanvas.Header closeButton className="sidebar-header">
         <Offcanvas.Title>메뉴</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="sidebar-body">

        <Nav defaultActiveKey="" className="flex-column">
          <div className="sidebar-menu">
            <div className="sidebar-menu-wrapper">
              <Nav.Link as={Link} to="/" className="nav-links" onClick={onLinkClick}>홈</Nav.Link>
            </div>
          </div>

          <div className="sidebar-menu">
            <div className="sidebar-menu-wrapper">
              <Nav.Link as={Link} to="/bestlist" className="nav-links" onClick={onLinkClick}>베스트셀러 크루즈</Nav.Link>
            </div>
          </div>

          {/* 지역별 크루즈 일정 */}
          <div className="sidebar-dropdown-menu">
            <div
              className="dropdown-menu-title-wrapper"
              onClick={() => toggleDropdown('region')}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
            >
              <h2 className="title">지역별 크루즈 일정</h2>
              <ArrowSVG style={{ transform: openDropdown === 'region' ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }} />
            </div>
            {Array.isArray(regionTabs) && openDropdown === 'region' && (
              <div className="sidebar-menu-wrapper">
                {regionTabs.map((opt, idx) => (
                  <Nav.Link
                    as="span"
                    key={idx}
                    className="nav-dropdown-links"
                    onClick={() => {
                      onLinkClick();
                      navigate(`/tabList?type=region&tabId=tab_${opt.id}`);
                    }}
                    style={{ display: 'block', padding: '5px 0' }}
                  >
                    {opt.name}
                  </Nav.Link>
                ))}
              </div>
            )}
          </div>

          {/* 선사별 크루즈 일정 */}
          <div className="sidebar-dropdown-menu">
            <div
              className="dropdown-menu-title-wrapper"
              onClick={() => toggleDropdown('line')}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
            >
              <h2 className="title">선사별 크루즈 일정</h2>
              <ArrowSVG style={{ transform: openDropdown === 'line' ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }} />
            </div>
            {Array.isArray(lineTabs) && openDropdown === 'line' && (
              <div className="sidebar-menu-wrapper">
                {lineTabs.map((opt, idx) => (
                  <Nav.Link
                    as="span"
                    key={idx}
                    className="nav-dropdown-links"
                    onClick={() => {
                      onLinkClick();
                      navigate(`/tabList?type=line&tabId=tab_${opt.id}`);
                    }}
                    style={{ display: 'block', padding: '5px 0' }}
                  >
                    {opt.name}
                  </Nav.Link>
                ))}
              </div>
            )}
          </div>

          <div className="sidebar-menu">
            <div className="sidebar-menu-wrapper">
              <Nav.Link as={Link} to="/bookmark" className="nav-links" onClick={onLinkClick}>찜한 여행</Nav.Link>
            </div>
          </div>

          <div className="sidebar-menu">
            <div className="sidebar-menu-wrapper">
              <Nav.Link as={Link} to="/review" className="nav-links" onClick={onLinkClick}>고객후기</Nav.Link>
            </div>
          </div>

          {user ? (
            <>
              <div className="sidebar-menu">
                <div className="sidebar-menu-wrapper">
                  <Nav.Link as={Link} to="/mypage" className="nav-links" onClick={onLinkClick}>마이페이지</Nav.Link>
                </div>
              </div>

              <div className="sidebar-menu">
                <div className="sidebar-menu-wrapper">
                  <Nav.Link as="span" className="nav-links" onClick={handleLogout} style={{ cursor: 'pointer' }}>로그아웃</Nav.Link>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="sidebar-menu">
                <div className="sidebar-menu-wrapper">
                  <Nav.Link as={Link} to="/register" className="nav-links" onClick={onLinkClick}>회원가입</Nav.Link>
                </div>
              </div>
              <div className="sidebar-menu">
                <div className="sidebar-menu-wrapper">
                  <Nav.Link as={Link} to="/login" className="nav-links" onClick={onLinkClick}>로그인</Nav.Link>
                </div>
              </div>
            </>
          )}
        </Nav>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
